<script setup>
  import { defineProps, ref, onMounted, watch } from 'vue'

  const props = defineProps({
    tool: String,
    form: Object,
    formDefaults: Object,
    formMutator: Function,
  })

  const copyFormLinkRef = ref(null);

  const hasMounted = ref(false);

  onMounted(()=>{
    hasMounted.value = true;
    setTimeout(()=>{
      for(const [key, value] of new URLSearchParams(window.location.hash.slice(1))) {
        if (props.formDefaults[key] != undefined){
          props.formMutator(key, value);
        }
      }
    }, 500);
  });


  const copyFormLink = ()=>{
    navigator.clipboard.writeText(window.location.href);
    copyFormLinkRef.value.innerText = "Copied!"
    setTimeout(()=>{
      copyFormLinkRef.value.innerText = "Copy Form Link"
    }, 1000);
  };

  let debounceTimer = 0;
  watch(props.form, ()=>{
    if (hasMounted.value){
      let params = {};
      for(var k in props.form){
        if (props.formDefaults[k] != undefined && props.form[k] != props.formDefaults[k]){
          params[k] = props.form[k];
        }
      }
      window.location.hash = new URLSearchParams(params);

      // Pulse the button when there's an update
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(()=>{
        copyFormLinkRef.value.classList.add('pulse-'+props.tool)
        setTimeout(()=>{
          copyFormLinkRef.value.classList.remove('pulse-'+props.tool)
        }, 2200);
      }, 200)
    }
  });

</script>
<template>
  <div ref="copyFormLinkRef" :class="'button text-white font-display !shadow-inner bg-tool-'+props.tool+' hover:bg-tool-'+props.tool+'/75'" @click="copyFormLink">
      Copy Form Link
  </div>
</template>
